import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './CareemHome.css';

function CareemHome() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const [activePromo, setActivePromo] = useState(0);

  const promos = [
    {
      id: 1,
      title: 'AI Study Assistant',
      subtitle: 'Boost your grades with AI',
      bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      icon: '🧠'
    },
    {
      id: 2,
      title: '50% Off Tutoring',
      subtitle: 'This week only!',
      bg: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
      icon: '📚'
    },
    {
      id: 3,
      title: 'Student Marketplace',
      subtitle: 'Buy & sell with students',
      bg: 'linear-gradient(135deg, #00eb79 0%, #00c966 100%)',
      icon: '🛒'
    }
  ];

  const mainServices = [
    { id: 'tutoring', title: 'Tutoring', icon: '📚', color: '#00eb79', path: '/services?category=tutoring' },
    { id: 'community', title: 'Community', icon: '👥', color: '#ec4899', path: '/community' },
    { id: 'market', title: 'Shop', icon: '🛒', color: '#3b82f6', path: '/marketplace' },
    { id: 'ai', title: 'AI Tools', icon: '🧠', color: '#667eea', path: '/mindwave' }
  ];

  const moreServices = [
    { id: 'rentals', title: 'Rentals', icon: '📦', path: '/rentals' },
    { id: 'services', title: 'Services', icon: '🔧', path: '/services' },
    { id: 'feed', title: 'Feed', icon: '📱', path: '/feed' },
    { id: 'tools', title: 'Tools', icon: '🎯', path: '/student-tools' },
    { id: 'chat', title: 'Chat', icon: '💬', path: '/community' },
    { id: 'events', title: 'Events', icon: '📅', path: '/services?category=events' },
    { id: 'isa', title: 'ISA', icon: '🌍', path: '/community/isa' },
    { id: 'more', title: 'More', icon: '⋯', path: '/services' }
  ];

  const recentActivity = [
    { id: 1, type: 'tutoring', title: 'Math Tutoring Session', time: '2 days ago', status: 'completed', icon: '📚' },
    { id: 2, type: 'service', title: 'Resume Review', time: '1 week ago', status: 'completed', icon: '📝' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActivePromo((prev) => (prev + 1) % promos.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [promos.length]);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="careem-app">
      {/* Header */}
      <header className="careem-header">
        <div className="header-left">
          <div className="location-selector">
            <span className="location-icon">📍</span>
            <div className="location-info">
              <span className="location-label">Current Location</span>
              <span className="location-value">Your Campus</span>
            </div>
            <span className="location-arrow">▼</span>
          </div>
        </div>
        <div className="header-right">
          <button className="header-btn notification-btn">
            <span className="notification-icon">🔔</span>
            <span className="notification-badge">3</span>
          </button>
          {user ? (
            <Link to="/profile" className="header-btn avatar-btn">
              <span>{user.name?.charAt(0).toUpperCase()}</span>
            </Link>
          ) : (
            <Link to="/login" className="header-btn login-btn">Sign In</Link>
          )}
        </div>
      </header>

      {/* Greeting Section */}
      <section className="greeting-section">
        <h1 className="greeting-text">
          {getGreeting()}{user ? `, ${user.name?.split(' ')[0]}` : ''}! 👋
        </h1>
        <p className="greeting-subtitle">What can we help you with today?</p>
      </section>

      {/* Search/Service Card - Main CTA */}
      <section className="ride-booking-section">
        <div className="ride-card" onClick={() => navigate('/services')}>
          <div className="ride-card-content">
            <div className="ride-input-group">
              <div className="ride-dot green"></div>
              <input
                type="text"
                placeholder="What do you need help with?"
                className="ride-input"
                readOnly
                onClick={() => navigate('/services')}
              />
            </div>
            <button className="ride-now-btn">
              <span>🔍</span>
            </button>
          </div>
          <div className="ride-suggestions">
            <button className="suggestion-chip" onClick={(e) => { e.stopPropagation(); navigate('/services?category=tutoring'); }}>
              <span>📚</span> Find a Tutor
            </button>
            <button className="suggestion-chip" onClick={(e) => { e.stopPropagation(); navigate('/marketplace'); }}>
              <span>🛒</span> Marketplace
            </button>
            <button className="suggestion-chip" onClick={(e) => { e.stopPropagation(); navigate('/mindwave'); }}>
              <span>🧠</span> AI Tools
            </button>
          </div>
        </div>
      </section>

      {/* Main Services - Careem Style */}
      <section className="main-services-section">
        <div className="main-services-grid">
          {mainServices.map((service) => (
            <div
              key={service.id}
              className="main-service-tile"
              onClick={() => navigate(service.path)}
            >
              <div className="main-service-icon" style={{ backgroundColor: service.color + '20' }}>
                <span>{service.icon}</span>
              </div>
              <span className="main-service-title">{service.title}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Promo Carousel */}
      <section className="promo-carousel-section">
        <div className="promo-carousel">
          {promos.map((promo, index) => (
            <div
              key={promo.id}
              className={`promo-slide ${index === activePromo ? 'active' : ''}`}
              style={{ background: promo.bg }}
            >
              <div className="promo-slide-content">
                <span className="promo-slide-icon">{promo.icon}</span>
                <div className="promo-slide-text">
                  <h3>{promo.title}</h3>
                  <p>{promo.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="promo-dots">
          {promos.map((_, index) => (
            <button
              key={index}
              className={`promo-dot ${index === activePromo ? 'active' : ''}`}
              onClick={() => setActivePromo(index)}
            />
          ))}
        </div>
      </section>

      {/* More Services Grid */}
      <section className="more-services-section">
        <h2 className="section-title">More Services</h2>
        <div className="more-services-grid">
          {moreServices.map((service) => (
            <div
              key={service.id}
              className="more-service-tile"
              onClick={() => navigate(service.path)}
            >
              <div className="more-service-icon">
                <span>{service.icon}</span>
              </div>
              <span className="more-service-title">{service.title}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Wallet Card */}
      <section className="wallet-section">
        <div className="wallet-card" onClick={() => navigate('/wallet')}>
          <div className="wallet-left">
            <span className="wallet-icon">💳</span>
            <div className="wallet-info">
              <span className="wallet-label">ONTAP Wallet</span>
              <span className="wallet-balance">$25.00</span>
            </div>
          </div>
          <div className="wallet-actions">
            <button className="wallet-action-btn" onClick={(e) => { e.stopPropagation(); navigate('/wallet/add'); }}>
              <span>+</span> Add
            </button>
          </div>
        </div>
      </section>

      {/* Rewards Section */}
      <section className="rewards-section">
        <div className="rewards-card">
          <div className="rewards-header">
            <span className="rewards-icon">🏆</span>
            <div className="rewards-info">
              <span className="rewards-title">ONTAP Rewards</span>
              <span className="rewards-points">250 points</span>
            </div>
          </div>
          <div className="rewards-progress">
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: '60%' }}></div>
            </div>
            <span className="rewards-next">150 points to next reward</span>
          </div>
          <button className="rewards-btn" onClick={() => navigate('/rewards')}>
            View Rewards →
          </button>
        </div>
      </section>

      {/* Recent Activity */}
      {user && recentActivity.length > 0 && (
        <section className="activity-section">
          <div className="section-header">
            <h2 className="section-title">Recent Activity</h2>
            <Link to="/activity" className="see-all-link">See All</Link>
          </div>
          <div className="activity-list">
            {recentActivity.map((activity) => (
              <div key={activity.id} className="activity-item">
                <div className="activity-icon">
                  <span>{activity.icon}</span>
                </div>
                <div className="activity-info">
                  <span className="activity-title">{activity.title}</span>
                  <span className="activity-time">{activity.time}</span>
                </div>
                <div className={`activity-status ${activity.status}`}>
                  {activity.status}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Safety Banner */}
      <section className="safety-section">
        <div className="safety-card">
          <span className="safety-icon">🛡️</span>
          <div className="safety-info">
            <span className="safety-title">Your safety matters</span>
            <span className="safety-subtitle">All providers are verified students</span>
          </div>
        </div>
      </section>

      {/* Bottom Spacer for Nav */}
      <div className="bottom-spacer"></div>
    </div>
  );
}

export default CareemHome;
